import { useTranslation } from "react-i18next"
import {
  ControlProps,
  GroupBase,
  SingleValueProps,
  DropdownIndicatorProps,
  ClearIndicatorProps,
} from "react-select"
import { inputBaseStyles } from "~/design-system/components/input"
import { clx, ChevronRightMiniIcon, CrossMiniIcon } from "~/design-system"

const Control = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  className,
  cx,
  children,
  innerRef,
  innerProps,
  isDisabled,
  isFocused,
  menuIsOpen,
  selectProps: { name },
}: ControlProps<Option, IsMulti, Group>) => {
  return (
    <div
      ref={innerRef}
      {...innerProps}
      id={name}
      className={clx(
        inputBaseStyles,
        "focus-within:shadow-borders-interactive-with-active h-10 pl-small box-border flex overflow-hidden p-0 !transition-colors",
        { "bg-ui-bg-disabled border-ui-border-subtle hover:border-ui-border-subtle shadow-none cursor-not-allowed": isDisabled },
        className
      )}
    >
      <div className="flex items-center w-full">
        {children}
      </div>
    </div>
  )
}

export const DropdownIndicator = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  innerProps,
  cx,
  children,
  className,
  selectProps: { menuIsOpen },
}: DropdownIndicatorProps<Option, IsMulti, Group>) => {
  return (
    <div
      {...innerProps}
      className={clx(
        "rotate-90 transition-all",
        {
          "-rotate-90": menuIsOpen,
        },
        className
      )}
    >
      {children || <ChevronRightMiniIcon />}
    </div>
  )
}

export const ClearIndicator = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  innerProps,
  className,
  cx,
  children,
}: ClearIndicatorProps<Option, IsMulti, Group>) => {
  const { t } = useTranslation()
  return (
    <div
      {...innerProps}
      role="button"
      aria-label={t("Clear the selected options")}
      className={clx("text-ui-fg-subtle hover:bg-ui-bg-field-hover rounded", className)}
    >
      {children || <CrossMiniIcon />}
    </div>
  )
}

export default Control
